import { useSelector } from 'react-redux'
import { selectors } from '../store'

const DEFAULT_PREFIX = '+48'

export const useCountryPrefix = (countryId?: string | number) => {
  const countries = useSelector(selectors.settings.getCountries)

  return (
    countries?.find(country => country.id === countryId)?.phonePrefix ||
    DEFAULT_PREFIX
  )
}
